"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var LockOpen = {
    name: 'LockOpen',
    suppressMirroring: true,
    tooltipKey: 'LockOpen.icon.label',
    render: function (props, svgRef) {
        return (react_1.default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", className: ['LockOpen', props.className].join(' '), width: "14", height: "14", x: "0", y: "0", version: "1.1", viewBox: "0 0 14 14", xmlSpace: "preserve", ref: svgRef }, props),
            props.tooltip && react_1.default.createElement("title", null, props.tooltip),
            react_1.default.createElement("path", { className: "svgToolTipPane", fill: "none", d: "M0 0h14v14H0z" }),
            react_1.default.createElement("path", { className: "iconColor", d: "M10 5H4.95c-.64-.854-.606-2.402.121-3.162.523-.547 1.356-.895 2.201-.852.753.021 1.413.315 1.857.832a.487.487 0 10.741-.636C9.244.453 8.33.036 7.297.009 6.181-.022 5.083.41 4.364 1.162c-.906.947-1.072 2.618-.524 3.854A1.994 1.994 0 002 7v5a2 2 0 002 2h6a2 2 0 002-2V7a2 2 0 00-2-2zm1 7c0 .551-.449 1-1 1H4c-.551 0-1-.449-1-1V7c0-.551.449-1 1-1h6c.551 0 1 .449 1 1v5zm-4-1a1 1 0 01-1-1V9a1 1 0 012 0v1a1 1 0 01-1 1z" })));
    },
};
exports.default = LockOpen;
